import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SidePanelState {
  open: boolean;
}

const initialState: SidePanelState = {
  open: true,
};

const counterSlice = createSlice({
  name: "sidePanel",
  initialState,
  reducers: {
    setSidePanelDispatch: (state, action: PayloadAction<boolean>) => {
      state.open = action.payload;
    },
  },
});

export const { setSidePanelDispatch } = counterSlice.actions;

export default counterSlice.reducer;
